import React from "react";

interface CollapsibleProps {
  open: boolean;
  /// Fades the content alongside the height. Off for a row's own body, where the
  /// content is the thing being revealed; on when the region is being filtered
  /// out from under the reader.
  fade?: boolean;
  className?: string;
  children: React.ReactNode;
}

/// Height animation for a region that expands in place: a `0fr↔1fr` grid track,
/// so it interpolates without JS measuring and works for content of unknown
/// height. The single shared implementation — dataset rows, token rows, and
/// filtered list rows all animate identically because they all render this.
export const Collapsible: React.FC<CollapsibleProps> = ({
  open,
  fade = false,
  className,
  children,
}) => (
  <div
    className="grid"
    style={{
      gridTemplateRows: open ? "1fr" : "0fr",
      transition: "grid-template-rows var(--duration-short) var(--ease-move)",
    }}
  >
    <div
      className="overflow-hidden"
      style={{
        minHeight: 0,
        ...(fade
          ? {
              opacity: open ? 1 : 0,
              transition: "opacity var(--duration-short) var(--ease-move)",
            }
          : {}),
      }}
      // Keeps a collapsed region's controls out of the tab order.
      inert={!open}
    >
      <div className={className}>{children}</div>
    </div>
  </div>
);
